import { TableBody } from '@client/toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExpanableTableWraper } from '../../components/expanable-table-wraper';
import { BuildingRow, PremiseRow } from './';
import { VacancyDetailsDto, PremisesVacancyCostDetailsDto } from '@client/api';

export const Table: React.FC<{
  data: VacancyDetailsDto[];
  isLoading: boolean;
  onSelected: (ids: Set<string>) => void;
  selectedYear: number;
}> = ({ data, isLoading, onSelected, selectedYear }) => {
  const { t } = useTranslation('reporting');

  const columns = [
    { key: 'name', label: t('vacancyCost.building') },
    { key: 'premisesCount', label: t('vacancyCost.premises') },
    { key: 'totalArea', label: t('vacancyCost.totalArea') },
    { key: 'costThisYear', label: t('vacancyCost.costByYear', { year: selectedYear }) },
    { key: 'costLastYear', label: t('vacancyCost.costByYear', { year: selectedYear - 1 }) },
    { key: 'availability.amount', label: t('vacancyCost.availability') },
    { key: 'percentChange', label: t('vacancyCost.percentChange') },
  ];
  return (
    <ExpanableTableWraper
      loading={isLoading}
      columns={columns}
      data={data}
      onSelected={onSelected}
      renderBody={(
        data,
        selectedRows,
        expandedRows,
        handleToggleSelect,
        handleKeyDownSelect,
        handleToggleExpand,
        handleKeyDownExpand,
      ) => (
        <TableBody>
          {data.map((building) => (
            <React.Fragment key={building.buildingId}>
              <BuildingRow
                building={building}
                selectedRows={selectedRows}
                handleToggleSelect={handleToggleSelect}
                handleKeyDownSelect={handleKeyDownSelect}
                handleToggleExpand={handleToggleExpand}
                handleKeyDownExpand={handleKeyDownExpand}
                expandedRows={expandedRows}
              />
              {expandedRows.has(building.buildingId) &&
                building.premises.map((premise: PremisesVacancyCostDetailsDto) => (
                  <PremiseRow key={`${building.buildingId}-${premise.spaceType}`} premise={premise} />
                ))}
            </React.Fragment>
          ))}
        </TableBody>
      )}
    />
  );
};
